// extracted by mini-css-extract-plugin
export default {"root":"Svw6b99cqfHjcMsertGd","wrap":"oj5Sd53PvtdhyAxD1vYF","title":"VyBO0vRi8ojauC5vpXQx","description":"QnpDILugryvU4um9N95N"};